import React from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './Etiquette.styles';

const Etiquette = props => {
  const { backColor, children, text, style, classes, hideArrow } = props;
  return (
    <div style={style} className={classes.etiquette}>
      <div
        className={classes.text}
        style={{
          border: `1px solid ${backColor}`,
          backgroundColor: backColor
        }}
      >
        <p className='h6 font-weight-bold truncText'>{text}</p>
      </div>
      {!hideArrow && (
        <ArrowDropDownIcon
          className={classes.arrowIcon}
          style={{
            color: backColor
          }}
          fontSize='large'
        />
      )}

      {children}
    </div>
  );
};

export default withStyles(styles)(Etiquette);
